import { orderBy } from 'lodash';
import { CalendarHierarchyItem } from './';

export function sortCalendarItems(items: CalendarHierarchyItem[]) {
  const primaryOrder = orderBy(items, e => Number(e.id.toString().slice(0, 1)));
  const secondaryOrder = orderBy(primaryOrder, e => Number(e.id.toString().slice(1)));
  return secondaryOrder;
}